import { getterTypes } from '@/core/constants'

export default {
	[getterTypes.OCORRENCIA.GET_INFORMACOES_OCORRENCIA]: (state) => state.informacoesOcorrencia,
	[getterTypes.OCORRENCIA.GET_INFORMACOES_ITENS_OCORRENCIA]: (state) => state.informacoesItens,
}
